export default {
    "Branding": "Image de marque",
    "First color": "Couleur principale",
    "Second color": "Couleur secondaire",
    "Logo": "Logo",
    "Generic background": "Fond générique",
    "Company name": "Nom de l'entreprise",
    "Company website URL": "URL du site web de l'entreprise",
}